// Search Widget Text
const searchPlaceholderText = document.getElementById('algolia-search')?.getAttribute('data-search-text');
const recentSearchesTitle = document.getElementById('algolia-search')?.getAttribute('data-recent-search-title');
const shopifyText = document.getElementById('algolia-shopify-data').dataset;
window.algoliaHitDistinctMap = {}; // initialize map for transposing hit._distinct values

function isValidUserData(userData) {
  return userData && Array.isArray(userData);
}

function shouldInjectRecord(position, start, end) {
  return position >= start && position <= end;
}

function formatMoney(amount) {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: shopifyText.currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
}

function formatRegiosPrice(price) {
  return parseInt(price.toFixed(2).toString().replace(/\D/g, ''), 10);
}

function addQueryParamToRelativeURL(relativePath, paramName, paramValue) {
  const url = new URL(relativePath, window.location.href);
  url.searchParams.append(paramName, paramValue);
  return url.pathname + url.search;
}

function getVariantBadges(variantDetails, has_dwo_tag) {
  if (!variantDetails || !variantDetails.picks) return [];
  const variantBadges = [];

  for (const pick of variantDetails.picks) {
    const variant = pick.variant;
    const badgeText = variant.badgeText || [];
    const badgeAuto = variant.badgeAuto || '';

    if (badgeAuto.length && badgeAuto.toLowerCase() !== 'sold out') {
      variantBadges.push(getBadgeTranslation(badgeAuto));
    } else if (badgeText.length) {
      variantBadges.push(getBadgeTranslation(badgeText[0]));
    } else if (has_dwo_tag) {
      variantBadges.push(shopifyText.pastSeasonPicks);
    } else {
      variantBadges.push('');
    }
  }
  return variantBadges;
}

function getBadgeTranslation(badgeText) {
  const translations = JSON.parse(shopifyText.badges);
  const translationKey = badgeText.toLowerCase().replaceAll(' ', '_');
  return translations[translationKey] || badgeText;
}

function getProductBadge(hit, has_dwo_tag, pageType) {
  const badgeText = hit.meta?.rvw?.badge_text || [];
  const badgeAuto = hit.meta?.rvw?.badge_auto || '';
  const variantDetails = hit.meta?.rvw?.variant_details || {};

  let result = {
    name: '',
    value: ''
  };

  if ((hit._distinct || pageType === 'recommend') && variantDetails.picks?.length === 0) {
    result.name = 'sold-out';
    result.value = shopifyText.soldOut;
  } else if (!hit._distinct && pageType === 'search' && badgeAuto.toLowerCase() === 'sold out') {
    result.name = badgeAuto.toLowerCase().replace(/\s+/g, '-');
    result.value = badgeAuto;
  } else if (!hit._distinct && pageType === 'search' && !hit.inventory_available) {
    result.name = 'sold-out';
    result.value = shopifyText.soldOut;
  } else if (badgeAuto.length && badgeAuto.toLowerCase() !== 'sold out') {
    result.name = badgeAuto.toLowerCase().replace(/\s+/g, '-');
    result.value = getBadgeTranslation(badgeAuto);
  } else if (badgeText.length) {
    result.name = (badgeText[0] || '').toLowerCase().replace(/\s+/g, '-');
    result.value = getBadgeTranslation(badgeText[0]);
  } else if (has_dwo_tag) {
    result.name = 'past-season-picks';
    result.value = shopifyText.pastSeasonPicks;
  }

  return result;
}

function getPrices(variantDetails) {
  if (!variantDetails?.picks) return [];
  const prices = variantDetails.picks.map((pick) => {
    const variant = pick.variant;
    if (!variant) return;
    const countryCode = shopifyText.country || 'US';
    const price = variant.pricesByCountry?.[countryCode]
      ? variant.pricesByCountry[countryCode].price?.amount
      : variant.price;
    const compareAtPrice = variant.pricesByCountry?.[countryCode]
      ? variant.pricesByCountry[countryCode].compareAtPrice?.amount
      : variant.compareAtPrice;
    const onSale = variant.onSaleByCountry ? variant.onSaleByCountry[countryCode] : variant.onSale;
    return {
      itemPrice: {
        price: Number(parseFloat(price).toFixed(2)) || 0
      },
      compareAtPrice: {
        price: Number(parseFloat(compareAtPrice).toFixed(2)) || 0
      },
      onSale: onSale || false
    };
  });
  return prices;
}

/*================== Product Card Template ==================*/

function productCardTemplate(hit, html, trackSearchAttribution, pageType) {
  const variantDetails = hit.meta?.rvw?.variant_details || {};
  const numOptions = variantDetails?.totalValues || '1';
  const adjustedHit = hit;
  // adjustedHit.image = !hit._distinct ? hit.image : variantDetails?.picks?.[0]?.variant?.image?.url || hit.image;
  // adjustedHit.price = !hit._distinct ? hit.price : hit.variants_min_price;
  const hitImage = algoliaShopify.helpers.renderImage(adjustedHit, 250);
  const comparePrices = hit.variants_compare_at_price_min && hit.variants_compare_at_price_min > hit.variants_min_price;
  // const hasPriceRange = hit.variants_max_price !== hit.variants_min_price;
  const normalized_tags = hit.tags && hit.tags.length > 0 ? hit.tags.join(',').toLowerCase().split(',') : '';
  const has_dwo_tag = normalized_tags.indexOf('dwo') > -1;
  const badges = getVariantBadges(variantDetails, has_dwo_tag);
  const productBadge = getProductBadge(hit, has_dwo_tag, pageType);
  const prices = getPrices(variantDetails);
  const desktopSwatchCircleLimit = 4; // Number of swatch circles on desktop including the "+X" button
  const mobileSwatchCircleLimit = 3; //  Number of swatch circles on mobile including the "+X" button
  let swatchCount = 0;

  // Market specific initial tile pricing
  const currencyCode = shopifyText.currency || 'USD';
  let hitPrice = hit.price;
  let hitComparePrice = hit.compare_at_price;
  const targetCurrencyProperty = 'market_pricing_' + currencyCode.toLowerCase();
  if (currencyCode !== 'USD' && targetCurrencyProperty in hit) {
    hitPrice = hit[targetCurrencyProperty].price;
    hitComparePrice = hit[targetCurrencyProperty].compare_at_price;
  }
  adjustedHit.price = hitPrice;
  adjustedHit.compare_at_price = hitComparePrice;

  /* Regios discounts app */
  let regiosVariants = [];
  let hitVariantMissing = true;
  variantDetails.picks?.forEach((element, index) => {
    if (element?.variant?.id) {
      if (element.variant.id === hit.objectID) {
        hitVariantMissing = false;
      }
      let regiosVariant = {
        id: parseInt(element.variant.id, 10),
        title: element.variant.title || ''
      };
      if (element.variant.price) {
        regiosVariant.priceInCents = formatRegiosPrice(prices[index].itemPrice.price);
      }
      if (element.variant.compareAtPrice) {
        regiosVariant.compareAtPriceInCents = formatRegiosPrice(prices[index].compareAtPrice.price);
      }
      regiosVariants.push(regiosVariant);
    }
  });

  if (hitVariantMissing) {
    regiosVariants.push({
      id: parseInt(hit.objectID, 10),
      title: hit.title || '',
      priceInCents: formatRegiosPrice(hitPrice),
      compareAtPriceInCents: formatRegiosPrice(hitComparePrice)
    });
  }

  const regiosTileData = {
    productId: hit.id,
    variantId: parseInt(hit.objectID, 10),
    regularPriceInCents: formatRegiosPrice(hitPrice),
    compareAtPriceInCents: formatRegiosPrice(hitComparePrice),
    collectionIds: hit.collection_ids,
    variants: regiosVariants
  };

  const productURL = algoliaShopify.helpers.instantsearchLink(hit);
  const variantURL = productURL.toLowerCase().indexOf('variant=') > 0 ? productURL : addQueryParamToRelativeURL(productURL, 'variant', hit.objectID)

  return html`
    <product-card class="card-wrapper product-card-wrapper underline-links-hover">
      <div
        class="card card--standard card--media variant-updated-url"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        data-regios-dopp-generic-product-id="${hit.id}"
        data-regios-tile-data="${JSON.stringify(regiosTileData)}"
        onClick="${() => {
          if (typeof trackSearchAttribution === 'function') {
            trackSearchAttribution(hit);
          }
        }}"
        style="--ratio-percent: 100%;"
      >
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">
          <div class="card__media">
            <div class="media media--transparent media--hover-effect">
              <img
                class="motion-reduce"
                loading="${hit.productPosition > 6 ? 'lazy' : 'eager'}"
                src="${hitImage.src}"
                srcset="${hitImage.srcset}"
                sizes="${hitImage.sizes}"
                alt="${hit.title}"
                width="2000"
                height="2000"
              />
            </div>
          </div>
          <div class="card__content">
            <div class="product-badges">
              <div
                class="card__badge ${[shopifyText.soldOut, shopifyText.comingSoon].indexOf(productBadge.value) > -1
                  ? 'hidden'
                  : ''}"
              >
                <span class="product-badge product-badge-regios badge"></span>
              </div>
              <div class="product-badge product-badge-${(productBadge.name || '').toLowerCase().replace(/\s+/g, '-')}">
                ${productBadge.value || ''}
              </div>
            </div>
            <div class="card__information">
              <h3 class="card__heading">
                <a
                  class="full-unstyled-link variant-updated-url"
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${variantURL}"
                  id="StandardCardNoMediaLink-template--20084844396782__product-grid-8935917093102"
                  title="${algoliaShopify.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}"
                >
                  ${hit.title}
                </a>
              </h3>
            </div>
          </div>
        </div>
        <div class="card__content">
          <div class="card__information">
            <div class="tile-option" data-option-position="2">
              ${hit._distinct &&
              numOptions > 1 &&
              variantDetails.picks?.map((option, index) => {
                // Skip rendering input on the 4th item if there are more than 4 picks
                if (swatchCount === desktopSwatchCircleLimit - 1 && numOptions > desktopSwatchCircleLimit) {
                  return null;
                }
                swatchCount++;
                return html`
                  <input
                    id="${variantDetails.product.id}-${variantDetails.product.handle}-radio-${index}"
                    type="radio"
                    class="hidden"
                    name="${variantDetails.product.id}-${variantDetails.product.handle}"
                    value="${option.id}"
                    data-variant-image="${option.variant?.image?.url || hit.image}"
                    data-variant-url="${shopifyText.siteName === 'smith' ? '/' + shopifyText.locale : ''}${option
                      .variant?.url || ''}"
                    data-variant-badge="${badges[index] || ''}"
                  />
                  <label
                    for="${variantDetails.product.id}-${variantDetails.product.handle}-radio-${index}"
                    class="tile-option-value ${swatchCount >= mobileSwatchCircleLimit
                      ? 'mobile-hide tablet-block'
                      : ''}"
                    tabindex="0"
                    type="button"
                  >
                    <span
                      class="swatch"
                      style="--swatch--background: ${option.swatch?.imageUrl
                        ? `url(${option.swatch?.imageUrl}&width=100); --swatch-focal-point: 50.0% 50.0%;`
                        : option.swatch?.color || option.variant?.image?.url
                        ? `url(${option.variant?.image?.url}&width=100); --swatch-focal-point: 50.0% 50.0%;`
                        : ''};"
                    >
                    </span>
                    <div class="hidden tile-option-price">
                      <div class="price">
                        <div class="price__container ${prices[index]?.onSale ? 'price--on-sale' : ''}">
                          <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline"> ${shopifyText.regularPrice} </span>
                            <span class="price-item price-item--regular">
                              ${algoliaShopify.helpers.displayPrice(prices[index]?.itemPrice, false)}
                            </span>
                          </div>
                          <div class="price__sale regios-dopp-generic-price-container">
                            <span class="visually-hidden visually-hidden--inline"> ${shopifyText.regularPrice} </span>
                            <span class="price-item price-item--regular regios-dopp-generic-price-item--regular">
                              <s> ${algoliaShopify.helpers.displayPrice(prices[index]?.compareAtPrice, false)} </s>
                            </span>
                            <span class="visually-hidden visually-hidden--inline"> ${shopifyText.salePrice} </span>
                            <span
                              class="price-item price-item--sale price-item--last regios-dopp-generic-price-item--sale"
                            >
                              ${algoliaShopify.helpers.displayPrice(prices[index]?.itemPrice, false)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                `;
              })}
              ${hit._distinct &&
              swatchCount > 0 &&
              numOptions > 1 &&
              html`
                <a
                  class="tile-options-link
                    ${numOptions > swatchCount && swatchCount < desktopSwatchCircleLimit
                    ? 'tablet-block'
                    : 'tablet-hide'}
                    ${numOptions === swatchCount && swatchCount < mobileSwatchCircleLimit
                    ? 'mobile-hide'
                    : 'mobile-block'}"
                  href="${productURL}"
                >
                  <span class="tile-options-link-content button button--secondary">
                    <span class="mobile-hide tablet-block">+${numOptions - swatchCount}</span>
                    <span class="mobile-block tablet-hide"
                      >+${numOptions -
                      swatchCount +
                      (swatchCount === mobileSwatchCircleLimit
                        ? 1
                        : swatchCount > mobileSwatchCircleLimit
                        ? 2
                        : 0)}</span
                    >
                  </span>
                </a>
              `}
            </div>
            <h3 class="card__heading h5">
              <a
                href="${variantURL}"
                class="full-unstyled-link variant-updated-url"
              >
                ${hit.title}
              </a>
            </h3>

            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price">
                <div class="price__container ${comparePrices ? 'price--on-sale' : ''}">
                  <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline"> ${shopifyText.regularPrice} </span>
                    <span class="price-item price-item--regular">
                      ${algoliaShopify.helpers.displayPrice(adjustedHit, false)}
                    </span>
                  </div>
                  <div class="price__sale regios-dopp-generic-price-container">
                    <span class="visually-hidden visually-hidden--inline"> ${shopifyText.regularPrice} </span>
                    <span class="price-item price-item--regular regios-dopp-generic-price-item--regular">
                      <s> ${algoliaShopify.helpers.displayStrikedPrice(hitPrice, hitComparePrice)} </s>
                    </span>
                    <span class="visually-hidden visually-hidden--inline"> ${shopifyText.salePrice} </span>
                    <span class="price-item price-item--sale price-item--last regios-dopp-generic-price-item--sale">
                      ${algoliaShopify.helpers.displayPrice(adjustedHit, false)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card__badge bottom left"></div>
      </div>
    </product-card>
  `;
}

function sponsoredTileTemplate(hit) {
  var descriptionStyle = hit.description.style ? `style="${hit.description.style}"` : '';
  var description = '';
  if (hit.description.text) {
    description = `<p class="sponsored-tile-copy ${hit.description.class || ''}" ${descriptionStyle}>
                    ${hit.description.text}
                  </p>`;
  }
  var ctaStyle = hit.cta.style ? `style="${hit.cta.style}"` : '';
  var cta = '';
  if (hit.cta && hit.cta.url && hit.cta.text) {
    cta = `<a href="${hit.cta.url}" class="button ${hit.cta.class || ''}" ${ctaStyle || 'button--secondary'}>
            ${hit.cta.text}
          </a>`;
  }
  var contentStyle = hit.content && hit.content.style ? `style="${hit.content.style}"` : '';
  return `<div class="plp-sponsored-tile">
            <img alt="${hit.image.alt}" src="${hit.image.url}" />
            <div class="sponsored-tile-content ${hit?.content?.class || ''}" ${contentStyle}>
              ${description}
              ${cta}
            </div>
          </div>`;
}

(function () {
  const collectionPage = window.RegiosDOPP_CollectionPage;
  if (!collectionPage) return;

  var pushState = history.pushState;
  history.pushState = function (state, title, url) {
    window.dispatchEvent(new CustomEvent('algolia:url-changed', {}));
    return pushState.apply(this, arguments);
  };

  var replaceState = history.replaceState;
  history.replaceState = function (state, title, url) {
    window.dispatchEvent(new CustomEvent('algolia:url-changed', {}));
    return replaceState.apply(this, arguments);
  };

  // Watch for collection page products array clear (done after pagination change)
  let currentDefault = collectionPage.default;
  Object.defineProperty(collectionPage, 'default', {
    configurable: true,
    enumerable: true,
    get() {
      return currentDefault;
    },
    set(newVal) {
      // Check if newVal exists and has an empty products array
      if (newVal?.products?.length === 0) {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('regios:after-collection-cleared', { detail: newVal }));
        }, 0);
      }
      // preform default function behavior
      currentDefault = newVal;
    }
  });

  var regiosProductSnapshot = [];

  // Pagination was click, mark next url change as a pagination change
  var isPaginationChange = false;
  window.addEventListener('algolia:pagination-clicked', (e) => {
    regiosProductSnapshot = RegiosDOPP_CollectionPage.default.products;
    isPaginationChange = true;
  });

  // If pagination url change, save snapshot before pagination change completes
  window.addEventListener('algolia:url-changed', (e) => {
    if (isPaginationChange) {
      regiosProductSnapshot = RegiosDOPP_CollectionPage.default.products;
      isPaginationChange = false;
    }
  });

  // Set snapshot back after regios clears array
  window.addEventListener('regios:after-collection-cleared', (e) => {
    RegiosDOPP_CollectionPage.default.products = regiosProductSnapshot;
  });
})();

/*================== Post-Render Alterations ==================*/

document.addEventListener('algolia.instantSearch.onRender', () => {
  // Add search term to "No Results" section if exists
  function updateNoResultsSearchTerm() {
    const searchBox = document.querySelector('.ais-SearchBox-input');
    const searchTerm = searchBox ? searchBox.value : '';
    const noResultsSection = document.querySelectorAll('.no-results-section');
    noResultsSection.forEach((section) => {
      if (section.innerHTML.includes('__SEARCHTERM__')) {
        section.innerHTML = section.innerHTML.replace(
          /__SEARCHTERM__/g,
          `<span class="no-results-term">${searchTerm}</span>`
        );
      } else {
        const termEl = section.querySelector('.no-results-term');
        if (termEl) {
          termEl.textContent = searchTerm;
        }
      }
    });
  }

  updateNoResultsSearchTerm();
  document.querySelector('.ais-SearchBox-input')?.addEventListener('input', updateNoResultsSearchTerm);
  document.querySelectorAll('.ais-Pagination-link').forEach((link) => {
    link.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent('algolia:pagination-clicked', {}));
    });
  });

  // Format text for "Current Refinements" labels
  const currentRefinements = document.querySelector('.ais-current-refined-values--list');
  if (!currentRefinements) return;
  const labels = document.querySelectorAll('.ais-current-refined-values--label');
  labels.forEach((label) => {
    let node = label.nextSibling;
    if (node && node.nodeType === Node.TEXT_NODE) {
      // Remove leading colon and space
      node.textContent = node.textContent.replace(' : ', '');
      // Price range formatting
      node.textContent = node.textContent.replace(
        /(\d+)\s*:\s*(\d+)/,
        (_, a, b) => `${formatMoney(a)} - ${formatMoney(b)}`
      );
    }
  });

  // "Clear Filters" button in mobile flyout menu
  document.querySelector('.mobile-facets__clear-filters').addEventListener('click', function () {
    document.querySelector('.ais-ClearRefinements-button')?.click();
  });

  // Add search count to mobile button
  const resultsEl = document.querySelector('.ais-stats--nb-results');
  const buttonCount = document.querySelector('.search-results-count');
  if (resultsEl && buttonCount) {
    const regex = /\d+/;
    const match = regex.exec(resultsEl.textContent);
    const resultsCount = match ? parseInt(match[0], 10) : null;
    buttonCount.textContent = resultsCount || 0;
  }

  // Accessibility for facet labels and option swatches
  document.querySelectorAll('.ais-facets label, label.tile-option-value').forEach((label) => {
    label.setAttribute('tabindex', '0');
    label.setAttribute('role', 'button');
    const checkbox = label.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.setAttribute('tabindex', '-1');
    }
    label.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        label.click();
      }
    });
  });

  // Search Filters Dropdowns
  document.querySelectorAll('.ais-facets-container .ais-DynamicWidgets-widget').forEach((facet) => {
    const header = facet.querySelector('.ais-Panel-header');
    if (!header) return;
    header.addEventListener('click', function (e) {
      facet.classList.toggle('opened');
      e.stopPropagation();
    });
  });
});

document.addEventListener('algolia.hooks.initialize', function () {
  /*================== Auto-Complete Options Hook ==================*/

  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
    options.placeholder = searchPlaceholderText;
    options.detachedMediaQuery = '(max-width: 1199px)';
    options.openOnFocus = true;

    const { createLocalStorageRecentSearchesPlugin } = window['@algolia/autocomplete-plugin-recent-searches'];

    const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
      key: 'recent-searches',
      limit: 4,
      transformSource({ source }) {
        return {
          ...source,
          templates: {
            item(params) {
              const { item, html } = params;
              return html`<a
                class="aa-ItemLink"
                href="${shopifyText.siteName === 'smith' ? '/' + shopifyText.locale : ''}/search?q=${item.id}"
              >
                ${source.templates.item(params).props.children}
              </a>`;
            }
          }
        };
      }
    });

    options.plugins = options.plugins || [];
    options.plugins.push(recentSearchesPlugin);

    const noResultsPlugin = {
      name: 'no-results-message',

      getSources({ state, query, setQuery, refresh }) {
        const noResults = JSON.parse(shopifyText.noResults) || {};

        return [
          // "No Results" message

          {
            sourceId: 'noResultsMessage',
            getItems() {
              return [{ label: noResults.label }];
            },
            templates: {
              item({ item, html }) {
                return html`
                  <div className="aa-NoResultsQuery">
                    <strong>${item.label} "${query}"</strong>
                  </div>
                  <div className="aa-NoResultsAdvices">
                    <ul className="aa-NoResultsAdvicesList">
                      <li>${noResults.line1}</li>
                      <li>${noResults.line2}</li>
                      <li>${noResults.line3}</li>
                      <li>${noResults.line4}</li>
                    </ul>
                  </div>
                `;
              }
            }
          }
        ];
      }
    };

    options.plugins.push(noResultsPlugin);

    const config = algoliaShopify.config;
    const localizedArticlesPlugin = {
      getSources({ query }) {
        return [
          {
            sourceId: 'articles',
            getItems() {
              return window.algoliaShopify.externals.getAlgoliaResults({
                searchClient: algoliaShopify.searchClient,
                queries: [
                  {
                    indexName: shopifyText.indexPrefix + 'articles' + shopifyText.indexSuffix,
                    query,
                    params: {
                      hitsPerPage: config.articles_autocomplete_hits_per_page,
                      clickAnalytics: config.analytics_enabled
                    }
                  }
                ]
              });
            },
            templates: {
              header({ html }) {
                return html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">${algoliaShopify.translations.articles}</span>
                    <div class="aa-SourceHeaderLine"></div>
                  </div>
                `;
              },
              item({ item, html }) {
                const articleURL = `${window.Shopify.routes.root}blogs/${item.blog.handle}/${item.handle}`;
                return html`
                  <a href="${articleURL}" class="aa-ItemLink">
                    <div class="aa-ItemWrapper">
                      <div class="aa-ItemContent">
                        <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                            />
                          </svg>
                        </div>
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">${item.title}</div>
                        </div>
                      </div>
                    </div>
                  </a>
                `;
              }
            }
          }
        ];
      }
    };

    const localizedPagesPlugin = {
      getSources({ query }) {
        return [
          {
            sourceId: 'pages',
            getItems() {
              return window.algoliaShopify.externals.getAlgoliaResults({
                searchClient: algoliaShopify.searchClient,
                queries: [
                  {
                    indexName: shopifyText.indexPrefix + 'pages' + shopifyText.indexSuffix,
                    query,
                    params: {
                      hitsPerPage: config.pages_autocomplete_hits_per_page,
                      clickAnalytics: config.analytics_enabled
                    }
                  }
                ]
              });
            },
            templates: {
              header({ html }) {
                return html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">${algoliaShopify.translations.pages}</span>
                    <div class="aa-SourceHeaderLine"></div>
                  </div>
                `;
              },
              item({ item, html }) {
                const pageURL = `${window.Shopify.routes.root}pages/${item.handle}`;
                return html`
                  <a href="${pageURL}" class="aa-ItemLink">
                    <div class="aa-ItemWrapper">
                      <div class="aa-ItemContent">
                        <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </div>
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">${item.title}</div>
                        </div>
                      </div>
                    </div>
                  </a>
                `;
              }
            }
          }
        ];
      }
    };

    options.plugins = options.plugins.map((plugin) => {
      if (plugin && plugin.name === 'aa.querySuggestionsPlugin') {
        // localize query suggestions
        plugin.__autocomplete_pluginOptions.indexName = shopifyText.indexPrefix + 'products_query_suggestions' + shopifyText.indexSuffix;
        return algoliaShopify.externals.createQuerySuggestionsPlugin(plugin.__autocomplete_pluginOptions);
      }
      if ('getSources' in plugin) {
        const getSources = plugin.getSources.toString();
        if (getSources.indexOf('sourceId:"articles"') > -1) {
          algoliaShopify.articlesPlugin = localizedArticlesPlugin;
          return localizedArticlesPlugin;
        } else if (getSources.indexOf('sourceId:"pages"') > -1) {
          algoliaShopify.pagesPlugin = localizedPagesPlugin;
          return localizedPagesPlugin;
        }
      }
      return plugin;
    });

    return options;
  });

  /*================== Auto-Complete Product Template Hook ==================*/

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;
      const normalized_tags = item.tags && item.tags.length > 0 ? item.tags.join(',').toLowerCase().split(',') : '';
      const has_dwo_tag = normalized_tags.indexOf('dwo') > -1;
      const badge = getProductBadge(item, has_dwo_tag, 'search');

      // Remove trailing slash from product link
      const itemLinkFinal = itemLink ? itemLink.replace(/\/$/, '') : '';
      return html`
        <a href="${itemLinkFinal}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              ${badge.value.toLowerCase() === shopifyText.pastSeasonPicks.toLowerCase() ||
              badge.value.toLowerCase() === shopifyText.sale.toLowerCase()
                ? html`
                    <div class="product-badges">
                      <div class="product-badge product-badge-${(badge.name || '').toLowerCase().replace(/\s+/g, '-')}">
                        ${badge.value || ''}
                      </div>
                    </div>
                  `
                : ''}
              <img
                loading="lazy"
                src="${algoliaShopify.helpers.renderImage(item, 125).src}"
                srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
                sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
                alt="${item.title}"
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentBrand">
                ${item.product_type && components.Highlight({ hit: item, attribute: 'product_type' })}
              </div>
              <div class="aa-ItemContentTitleWrapper">
                <div class="aa-ItemContentTitle">
                  ${components.Highlight({ hit: item, attribute: 'title' })}
                  <span class="algolia-variant"> ${algoliaShopify.helpers.variantTitleAddition(item, distinct)} </span>
                </div>
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent">${algoliaShopify.helpers.displayPrice(item, distinct)}</div>
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  /*================== Auto-Complete Template Hook ==================*/

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteMainTemplate',
    function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html } = templateOptions;

      // Get product search results
      const productSearchResults = templateOptions.state.collections.filter((c) => c.source.sourceId === 'products');

      // If no product results, show "No Results" section

      if (productSearchResults[0].items.length === 0) {
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSections">
              <div class="aa-PanelSection--left">
                ${elements.recentSearchesPlugin
                  ? html`
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle">${recentSearchesTitle}</span>
                        <div class="aa-SourceHeaderLine"></div>
                      </div>
                      ${elements.recentSearchesPlugin}
                    `
                  : ''}
                ${displaySuggestions
                  ? html`
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle">${algoliaShopify.translations.suggestions}</span>
                        <div class="aa-SourceHeaderLine"></div>
                      </div>
                      ${elements.querySuggestionsPlugin}
                    `
                  : ''}
                ${elements.articles} ${elements.collections} ${elements.pages} ${elements.redirectUrlPlugin}
              </div>
              <div class="aa-PanelSection--right algolia-no-results-right-panel">
                ${elements.noResultsMessage || ''}
              </div>
            </div>
          </div>
        `;
      } else {
        // Regular display with product results

        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSections">
              <div class="aa-PanelSection--left">
                ${elements.recentSearchesPlugin
                  ? html`
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle">${recentSearchesTitle}</span>
                        <div class="aa-SourceHeaderLine"></div>
                      </div>
                      ${elements.recentSearchesPlugin}
                    `
                  : ''}
                ${displaySuggestions
                  ? html`
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle">${algoliaShopify.translations.suggestions}</span>
                        <div class="aa-SourceHeaderLine"></div>
                      </div>
                      ${elements.querySuggestionsPlugin}
                    `
                  : ''}
                ${elements.articles} ${elements.collections} ${elements.pages}
                ${elements.redirectUrlPlugin}
              </div>
              <div class="aa-PanelSection--right">${elements.products}</div>
            </div>
          </div>
        `;
      }
    }
  );

  /*================== Instant Search - Product Card Template Hook ==================*/

  algoliaShopify.hooks.registerHook(
    'beforeInstantSearchProductTemplate',
    function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
      if (window.algoliaHitDistinctMap && !(hit.objectID in window.algoliaHitDistinctMap)) {
        window.algoliaHitDistinctMap[hit.objectID] = hit._distinct;
      }
      return '';
      // return productCardTemplate(hit, html, trackSearchAttribution, 'search');
    }
  );

  /*================== Recommendations - Product Card Template Hook ==================*/

  algoliaShopify.hooks.registerHook('beforeRecommendHitTemplate', function (_defaultTemplate, html, item) {
    return productCardTemplate(item, html, null, 'recommend');
  });

  /*================== Instant Search - Main Search Template Hook ==================*/

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>

        <div class="ais-search-header">
          <div class="ais-stats-container"></div>
          <div class="ais-change-display">
            <span class="ais-change-display-block ais-change-display-selected">
              <i class="fa fa-th-large"></i>
            </span>
            <span class="ais-change-display-list">
              <i class="fa fa-th-list"></i>
            </span>
          </div>
          <div class="selected-filters">
            <div id="algolis-current-refinements-container" class="ais-current-refined-values-container"></div>
            <div class="ais-clear-refinements-container"></div>
          </div>
          <div class="ais-sort">
            <button class="sort-button button button--secondary" type="button" tabindex="0">${shopifyText.sort}</button>
            ${data.multipleSortOrders
              ? html` <span class="ais-sort-orders-container"></span> `
              : html` ${algoliaShopify.translations.relevance} `}
          </div>
          <button class="facets-drawer-close button button--secondary" aria-hidden="true" type="button">
            ${shopifyText.filters}
          </button>
        </div>

        <div class="ais-facets-button" style="display: none;"></div>

        <facets-drawer class="mobile-facets__wrapper">
          <div class="facets-details mobile-facets__disclosure disclosure-has-popup">
            <div class="facets-summary mobile-facets__open-wrapper focus-offset">
              <span class="mobile-facets-button" aria-hidden="true" style="display: none;"></span>
            </div>
            <div class="mobile-facets">
              <div class="mobile-facets__inner gradient">
                <div class="mobile-facets__header">
                  <div class="mobile-facets__header-bar">
                    <button class="mobile-facets__close" tabindex="0">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
                        <path
                          fill="currentColor"
                          d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="mobile-facets__secondary-bar">
                  <button class="mobile-facets__close button button--primary" type="button">
                    ${shopifyText.see} <span class="search-results-count">0</span> ${shopifyText.results}
                  </button>
                  <button type="button" class="mobile-facets__clear-filters">${shopifyText.removeAllFilters}</button>
                </div>
                <div class="ais-facets-container">
                  <div class="ais-facets">
                    ${algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
                      ? html` <div class="ais-dynamic-widgets-container"></div> `
                      : data.facets.map(
                          (facet) => html`
                            <div
                              class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                            >
                              <input
                                class="ais-dropdown-checkbox"
                                type="checkbox"
                                id="${facet.escapedName}"
                                name="dropdown"
                                checked
                              />
                              <label
                                class="ais-range-slider--header ais-facet--header ais-header"
                                for="${facet.escapedName}"
                                tabindex="0"
                                role="button"
                                aria-pressed="false"
                              >
                                ${facet.title}
                              </label>
                              <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                            </div>
                          `
                        )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </facets-drawer>
        <div class="ais-block">
          <div id="algolia-hits" class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

  /*================== Instant Search - Results Count Template ==================*/

  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function (_defaultTemplate, data, html) {
    return html`
      ${data.hasOneResult && html` <span class="ais-stats--nb-results"> 1 result found </span> `}
      ${data.hasManyResults &&
      html`
        ${data.page * data.hitsPerPage + 1} - ${' '} ${Math.min((data.page + 1) * data.hitsPerPage, data.nbHits)} ${' '}
        out of
        <span class="ais-stats--nb-results">
          ${' '} ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '} results
        </span>
      `}
    `;
  });

  /*================== Instant Search - Filter Header Template ==================*/

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetPanelOptions', function (params, facet) {
    return {
      ...params,
      templates: {
        header(options, { html }) {
          if (options.results) {
            return html`<span class="ais-facet--header">${facet.title}</span>`;
          }
        }
      }
    };
  });

  /*================== Instant Search - No Results Template Hook ==================*/

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function (_defaultTemplate, html) {
    // Hide facets and pagination when no results
    // Show any "No Results" section added to theme (product carousel, text block, etc.)
    return html`
      <style>
        .ais-search-header,
        .mobile-facets__wrappe,
        .ais-pagination-container,
        .mobile-facets__wrapper {
          display: none !important;
        }
        .no-results-section {
          display: block !important;
        }
        #algolia-shopify-instantsearch .ais-block {
          width: 100%;
          padding: 0;
        }
        #algolia-shopify-instantsearch {
          min-height: 0 !important;
        }
      </style>
    `;
  });

  /*================== Instant Search - Hook for Custom Collection Pages ==================*/

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function (defaultFilter) {
    if (defaultFilter?.includes('collection_ids')) {
      const collectionIDFilterRegex = /collection_ids:"\w+"/g;
      const matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
      const collectionHandle = matches && matches.length === 2 ? matches[1] : null;

      if (collectionHandle) {
        if (collectionHandle.startsWith('v-')) {
          // If handle starts with v- → custom Algolia collection
          const newHandle = collectionHandle.replace('v-', '').replaceAll('-', ' ');
          return defaultFilter.replace(collectionIDFilterRegex, `_collections:"${newHandle}"`);
        } else {
          return defaultFilter.replace(collectionIDFilterRegex, 'collections:' + collectionHandle);
        }
      }
    }

    return defaultFilter;
  });

  /*================== Instant Search - Hook for Search Options ==================*/

  algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function (options) {
    // If URL contains `/collections/v-`, then it's a custom collection so show individual variant products
    if (window.location.pathname.includes('/collections/v-')) {
      options.distinct = false;
    }

    return options;
  });

  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function () {
    let result = [];
    const allWidgets = window.algoliaShopify?.externals?.widgets || null;
    if (allWidgets === null) {
      return result;
    }

    const { configure, hits } = allWidgets;
    if (configure) {
      const isSearch = document.querySelector('.template-search') !== null;
      if (isSearch) {
        const configureWidget = configure({
          ruleContexts: ['search_page']
        });
        result.push(configureWidget);
      }
    }

    if (hits) {
      const hitsWidget = hits({
        container: '#algolia-hits',
        transformItems: (items, { results }) => {
          let response = algoliaShopify.instantsearch.search.mainIndex.getResults();
          let userData = response ? response.userData : null;

          items.forEach((item) => {
            if (item.objectID in algoliaHitDistinctMap) {
              item._distinct = algoliaHitDistinctMap[item.objectID];
            }
          });
          window.algoliaHitDistinctMap = {}; // clear map
          if (typeof RegiosDOPP_CollectionPage !== 'undefined') {
            RegiosDOPP_CollectionPage.default.products = []; // clear regios collection page products with each pagination change
          }

          if (isValidUserData(userData)) {
            const start = results.page * results.hitsPerPage;
            const end = start + results.hitsPerPage - 1;
            const injectionOffset = start + 1;

            userData.forEach((record) => {
              record.sponsored = true;
              if (shouldInjectRecord(record.position, start, end)) {
                items.splice(record.position - injectionOffset, 0, record);
              }
            });
          }
          return items;
        },
        templates: {
          item(hit, { html, sendEvent, components }) {
            if (hit.sponsored) {
              return sponsoredTileTemplate(hit);
            }
            return productCardTemplate(hit, html, null, 'search');
          }
        }
      });
      result.push(hitsWidget);
    }

    return result;
  });
});
